import {InputHTMLAttributes} from 'react';
import {FieldError, UseFormRegister} from 'react-hook-form';
import {cn} from '@/lib/utils';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  register?: UseFormRegister<any>;
  name: string;
  className?: string;
  error?: FieldError | undefined;
};

export default function InputRoot({
  register,
  name,
  className,
  error,
  ...props
}: Props) {
  return (
    <input
      id={name}
      {...register?.(name)}
      className={cn(
        'apperance-none min-h-[44px] w-full h-[2.5625rem] rounded-none py-2 px-4 text-md leading-[1.625] text-graphite flex  bg-gray-100 border focus:border-primary outline-none',
        error ? 'border-error-primary' : 'border-gray-200',
        className,
      )}
      {...props}
    />
  );
}
